"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function SelectSearch(props) {
    const options = props.options;
    const setSelectedValue = props.setSelectedValue;
    const label = props.label;
    const defaultValue = props.defaultValue;
    const valueKeyWord = props.valueKeyWord;
    const nameKeyWord = props.nameKeyWord;
    const [filterdOptions, setFilterdOptions] = react_1.default.useState(options);
    // const [filterdOptions, setFilterdOptions] = React.useState(options)
    react_1.default.useEffect(() => {
        setFilterdOptions(options);
    }, [options]);
    function searchInputChange(q) {
        setFilterdOptions(options.filter(option => {
            return option[nameKeyWord !== null && nameKeyWord !== void 0 ? nameKeyWord : 'name'].slice(0, q.length).toLowerCase() == q.toLowerCase();
        }));
    }
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement("input", { type: 'text', onChange: e => { searchInputChange(e.target.value); }, placeholder: label }),
        react_1.default.createElement("select", { className: "form-control", onChange: (e) => { setSelectedValue(e.target.value); setFilterdOptions(options); }, size: filterdOptions.length < options.length ? 5 : null, value: defaultValue !== null && defaultValue !== void 0 ? defaultValue : '' },
            react_1.default.createElement("option", { value: null }, ''), filterdOptions === null || filterdOptions === void 0 ? void 0 :
            filterdOptions.map((option, index) => (react_1.default.createElement("option", { key: index, value: option[valueKeyWord !== null && valueKeyWord !== void 0 ? valueKeyWord : 'value'] }, option[nameKeyWord !== null && nameKeyWord !== void 0 ? nameKeyWord : 'name']))))));
}
exports.default = SelectSearch;
